import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import propTypes from 'prop-types';
import InfoTip from '../../InfoTip';
import styles from './BarChart.module.scss';
import { getDefaultChartColors } from '../chart-colors';
import { tooltipConfig, gridConfig, animationConfig } from '../chart-config';

ChartJS.register(ArcElement, BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend);

const BarChart = ({ title, header, info, legendConfig = { display: false }, chartData }) => {
  const { labels, barTitle, backgroundColors, data } = chartData;

  const palette = getDefaultChartColors();
  const chartDataSets = data.map((dataSet, index) => ({
    label: barTitle[index],
    data: dataSet,
    backgroundColor: backgroundColors ? backgroundColors[index] : palette,
    borderRadius: 6,
    borderSkipped: false,
    maxBarThickness: 48,
  }));

  const preparedChartData = {
    labels,
    datasets: chartDataSets,
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: legendConfig,
      tooltip: tooltipConfig,
      datalabels: { display: false },
    },
    scales: {
      x: {
        ...gridConfig.x,
        stacked: true,
      },
      y: {
        ...gridConfig.y,
        stacked: true,
      },
    },
    animation: animationConfig,
  };

  return (
    <div className={styles.chartCard}>
      <div className={styles.salesChart}>
        <div className={styles.chartHeader}>
          <span className={styles.chartTitle}>
            {title}
            {info && <InfoTip content={info} label={`About ${title}`} />}
          </span>
          {header ? (
            <div className={styles.salesInfo}>
              <h2>
                {`${header.value} `}
                {header.difference ? (
                  <span
                    className={
                      styles.percentage +
                      (header.difference.startsWith('-') ? ` ${styles.negative}` : '')
                    }
                  >
                    {header.difference}
                  </span>
                ) : null}
              </h2>
              {header.label ? <p>{header.label}</p> : null}
            </div>
          ) : null}
        </div>
        <div className={styles.barChart}>
          <Bar data={preparedChartData} options={options} />
        </div>
      </div>
    </div>
  );
};

BarChart.propTypes = {
  title: propTypes.string,
  header: propTypes.object,
  info: propTypes.node,
  legendConfig: propTypes.object,
  chartData: propTypes.object,
};

export default BarChart;
